<template>
  <label for="yogaType" class="g--label mt-4  mb-1">
    Yoga Type
  </label>
  <select
      required
      v-model="selectedType"
      class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
  >
    <option value="" disabled>Select a yoga type</option>
    <option
        v-for="type in yogaTypes"
        :key="type.id"
        :value="type.id"
    >
      {{ type.title }}
    </option>
  </select>
</template>

<script setup>
import { ref, onMounted, watch } from 'vue';

const props = defineProps({
  classItem: {
    type: Object,
    required: true,
  },
});

const yogaTypes = ref([]);
const selectedType = ref('');

onMounted(() => {
  console.log(props.classItem);
  getYogaTypes();
  // Pre-select the active type based on classItem

});

const getYogaTypes = async () => {
  try {
    const response = await fetch('/api/various/yoga-types');
    const data = await response.json();
    yogaTypes.value = data;
    console.log(props.classItem?.yogaTypeId)
    if (props.classItem?.yogaTypeId) {
      selectedType.value = props.classItem.yogaTypeId;
    }
  } catch (error) {
    console.error('Error fetching yoga types:', error);
  }
};

// Optional: Emit the selected value to parent component
const emit = defineEmits(['update:type']);

// Watch for changes in selection
watch(selectedType, (newValue) => {
  console.log(newValue);
  emit('update:type', newValue);
});
</script>